//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { FieldMode } from './Enums';

export class WebsiteBlockSignupFormAdditionalFieldsDisplayItem extends ItemBase {
    Address: FieldMode = FieldMode.NotPresent;
    Birthday: FieldMode = FieldMode.NotPresent;
    FaceTimeID: FieldMode = FieldMode.NotPresent;
    Gender: FieldMode = FieldMode.NotPresent;
    LocalSchool: FieldMode = FieldMode.NotPresent;
    PreferredTeacher: FieldMode = FieldMode.NotPresent;
    Referrer: FieldMode = FieldMode.NotPresent;
    SkillLevel: FieldMode = FieldMode.NotPresent;
    SkypeUsername: FieldMode = FieldMode.NotPresent;
    Subjects: FieldMode = FieldMode.NotPresent;     // OBSOLETE - Use only for compatibility
    SubjectTag: FieldMode = FieldMode.NotPresent;
    ChildEmail: FieldMode = FieldMode.NotPresent;
    ChildPhone: FieldMode = FieldMode.NotPresent;

    constructor(initializer?: Partial<WebsiteBlockSignupFormAdditionalFieldsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteBlockSignupFormAdditionalFieldsDisplayItem";
}
